import React, { useContext, useEffect, useState } from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { PredefinedIndexesContext, VesselDwtTypesContext } from '../TcIndexPage';

function IndexSelector({ hireData, changeFieldsMultiple, countIndex }) {
    const indexes = useContext(PredefinedIndexesContext);
    const dwtGroups = useContext(VesselDwtTypesContext);
    const [currentIndex, setCurrentIndex] = useState(hireData.predefinedTcIndex);
    const [shouldRecheck, setShouldRecheck] = useState(true);

    useEffect(() => {
        if (shouldRecheck) {
            const found = indexes.find(index => {
                return index.clean === hireData.clean &&
                    index.roundTrip === hireData.roundTrip &&
                    (
                        hireData.vesselDwtGroup ?
                            index.vesselType === hireData.vesselDwtGroup.name 
                        :
                            true
                    ) &&
                    (
                        index.preciseFrom && index.preciseFrom.length ?  
                            checkInMultiple(index.preciseFrom, hireData.placeFrom)
                        :
                            checkInMultiple(index.from, hireData.regionFrom)
                    ) &&
                    (
                        index.preciseTo && index.preciseTo.length ?  
                            checkInMultiple(index.preciseTo, hireData.placeTo)
                        :
                            checkInMultiple(index.to, hireData.regionTo)
                    ) &&
                    checkInMultiple(index.via, hireData.via);
            });
    
            if (found) {
                setCurrentIndex(found);
            } else {
                setCurrentIndex({});
            }
        } else {
            setShouldRecheck(true);
        }
    }, [
        hireData.clean, hireData.roundTrip, hireData.vesselDwtGroup, 
        hireData.placeFrom, hireData.placeTo, 
        hireData.regionFrom, hireData.regionTo,
        hireData.via
    ]);

    const checkInMultiple = (indexValue, hireValue) => {
        if (indexValue.length === 0) return true;
        if (!hireValue) return false;

        const found = indexValue.findIndex(v => v._id === hireValue._id);

        if (found >= 0) return true;

        return false;
    }

    const hanleChangeIndex = (value) => {
        const index = indexes.find(i => i._id === value);
        setCurrentIndex(index);
        setShouldRecheck(false);

        const typeGeneral = dwtGroups.filter(d => d.name).find(d => d.name === index.vesselType);
        changeFieldsMultiple([
            { index: countIndex, field: 'predefinedTcIndex', value: index },
            { index: countIndex, field: 'clean', value: index.clean },
            { index: countIndex, field: 'roundTrip', value: index.roundTrip },
            { index: countIndex, field: 'placeFrom', value: index.preciseFrom ? index.preciseFrom[0] : {} },
            { index: countIndex, field: 'placeTo', value: index.preciseTo ? index.preciseTo[0] : {} },
            { index: countIndex, field: 'regionFrom', value: index.from[0] },
            { index: countIndex, field: 'regionTo', value: index.to[0] },
            { index: countIndex, field: 'via', value: index.via[0] },
            { 
                index: countIndex, 
                field: 'vesselDwtGroup', 
                value: dwtGroups.filter(d => d.name).find(d => d.name === index.vesselType) 
            } || {},
            { 
                index: countIndex, 
                field: 'typeGeneral', 
                value: typeGeneral ? typeGeneral.typeByPurpose[0] : '',
            },
            { 
                index: countIndex, 
                field: 'typeByPurpose', 
                value: typeGeneral ? typeGeneral.typeByPurpose[0] : '',
            },
            { index: countIndex, field: 'vessel.imoNumber', value: '' },
            { index: countIndex, field: 'vesselId', value: null },
        ]);
    }

    return (
        <div>
            <SelectField
                value={currentIndex && currentIndex._id}
                onChange={(_e, _i, val) => hanleChangeIndex(val)}
                style={{ width: '100%', fontSize: '10px' }}
                iconStyle={{ display: 'none' }}
                underlineStyle={{ display: 'none' }}
                labelStyle={{ height: '45px', padding: 0 }}
                floatingLabelStyle={{ fontSize: '10px' }}
                autoWidth
            >
                {
                    indexes.length && indexes.map(i => {
                        return (
                            <MenuItem 
                                value={i._id} 
                                primaryText={i.name}
                                key={i._id}
                            />
                        );
                    })
                }
            </SelectField>
        </div>
    );
}

export default React.memo(IndexSelector);



// WEBPACK FOOTER //
// ./app/components/TcIndex/RowData/IndexSelector.jsx